import { render, staticRenderFns } from "./relatedAdvertise.vue?vue&type=template&id=63bb5545&scoped=true"
import script from "./relatedAdvertise.vue?vue&type=script&lang=js"
export * from "./relatedAdvertise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb5545",
  null
  
)

export default component.exports